export const NETWORK_ERROR =
  'No internet connection. Please check your network and try again.';

export const UN_AUTHORIZED_ERROR = 'Unauthorized access. Please log in again.';
export const PERMISSION_ERROR =
  'You do not have permission to perform this action.';
export const NOT_FOUND_ERROR = 'Requested resource not found.';
export const SERVER_ERROR = 'Server error. Please try again later.';
export const BAD_GATEWAY_ERROR =
  'Bad Gateway – The server received an invalid response. Please refresh and try again.';
export const SERVICE_UNAVAILABLE_ERROR =
  'Service Unavailable – The server is temporarily unavailable. Please try again later.';
export const GATEWAY_TIMEOUT_ERROR =
  'Gateway Timeout – The server took too long to respond. Please check your connection or try again later.';
export const UNKNOWN_SERVER_ERROR =
  'An unexpected error occurred. Please try again later.';

export const SERVER_NOT_RESPONDING_ISSUE =
  'We are having trouble reaching our servers. Please try again later.';
